import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../Icon/Icon.js';

var styles = {
  "unit-base": "4",
  "badge": "web_ui__Badge__badge",
  "content": "web_ui__Badge__content",
  "icon": "web_ui__Badge__icon",
  "custom-icon": "web_ui__Badge__custom-icon",
  "filled": "web_ui__Badge__filled",
  "default": "web_ui__Badge__default",
  "primary": "web_ui__Badge__primary",
  "success": "web_ui__Badge__success",
  "warning": "web_ui__Badge__warning",
  "amplified": "web_ui__Badge__amplified",
  "muted": "web_ui__Badge__muted",
  "expose": "web_ui__Badge__expose",
  "light": "web_ui__Badge__light"
};

var BADGE_STYLING_VALUES = ['filled', 'light'];
/* ---------- Back-compat shims (public API) ---------- */
var BADGE_STYLING = {
  Filled: 'filled',
  Light: 'light'
};

/* ---------- Type definitions ---------- */

var cssClasses = classNames.bind(styles);
var BadgeBase = function BadgeBase(_ref) {
  var theme = _ref.theme,
    content = _ref.content,
    testId = _ref.testId,
    _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? 'filled' : _ref$styling,
    icon = _ref.icon,
    iconName = _ref.iconName;
  var renderIcon = function renderIcon() {
    if (!icon && !iconName) return null;
    var iconClass = cssClasses(styles.icon, _defineProperty({}, styles['custom-icon'], !!icon));
    return /*#__PURE__*/jsx("div", {
      className: iconClass,
      children: icon || iconName && /*#__PURE__*/jsx(Icon, {
        name: iconName,
        testId: getTestId(testId, 'icon')
      })
    });
  };
  var badgeClass = cssClasses(styles.badge, theme || 'default', styling);
  var showContent = (content || content === 0) && (!Array.isArray(content) || content.length);
  return /*#__PURE__*/jsxs("div", {
    className: badgeClass,
    "data-testid": testId,
    children: [renderIcon(), showContent ? /*#__PURE__*/jsx("div", {
      className: styles.content,
      "data-testid": getTestId(testId, 'content'),
      children: content
    }) : null]
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Badge = _Object$assign(BadgeBase, {
  /** @deprecated Use string unions, e.g. styling="light" */
  Styling: BADGE_STYLING
});

export { BADGE_STYLING, BADGE_STYLING_VALUES, Badge, Badge as default };
//# sourceMappingURL=Badge.js.map
